module.exports = __webpack_public_path__ + "img/bell.c5608eb4.svg";